import { colors } from "@src/constants"
import React from "react"
import { Form, Row } from "react-bootstrap"
import * as Icon from "react-bootstrap-icons"

type BatteryProps = {
  batteryValue?: number
  charging?: boolean
}

export const Battery: React.FC<BatteryProps> = ({ batteryValue, charging }) => {
  const colorFills =
    batteryValue <= 10 ? colors.red : batteryValue <= 25 ? colors.mustardYellow : colors.darkGray

  const BatteryIcons = () => {
    if (charging) {
      return <Icon.BatteryCharging color={colors.green} size={20} />
    } else {
      switch (true) {
        case batteryValue < 25:
          return <Icon.Battery color={colorFills} size={23} />
        case batteryValue >= 25 && batteryValue < 75:
          return <Icon.BatteryHalf color={colorFills} size={23} />
        case batteryValue >= 75 && batteryValue <= 100:
          return <Icon.BatteryFull color={colorFills} size={23} />
        default:
          break
      }
    }
  }

  return (
    <Row>
      <div className="d-flex align-items-center ms-3">
        <BatteryIcons />
        <Form.Text className="ms-2 mb-1" muted>
          {batteryValue}%
        </Form.Text>
      </div>
    </Row>
  )
}
